import { createContext, useContext } from 'react';
import { store, IGlobalStore } from '@store/index';

export const StoreContext = createContext(store);

const useStore = (): IGlobalStore => useContext(StoreContext);

export default useStore;
